<template>
  <div :id="$attrs['id']" class="loading__backdrop">
    <svg class="spinner"
         width="40px"
         height="40px"
         viewBox="0 0 66 66"
         xmlns="http://www.w3.org/2000/svg">
      <circle class="path"
              fill="none"
              stroke-width="6"
              stroke-linecap="round"
              cx="33"
              cy="33"
              r="30"></circle>
    </svg>
  </div>
</template>

<script>

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import { clone, isNil, startsWith } from 'lodash';

export default {
  name: 'SpinnerOverlay',

  props: {
  },

  data() {
    return {
    };
  },

  computed: {
  },

  methods: {
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import '~styles/import';

  .loading__backdrop {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba($white, 0.5);
    z-index: 99999;
    transition: opacity 0.15s ease;
    opacity: 1;
    backdrop-filter: blur(2px) grayscale(60%);

    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: all;

    // Here is where the magic happens

    $offset: 187;
    $duration: 1.4s;

    .spinner {
      animation: rotator $duration linear infinite;
    }

    @keyframes rotator {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(270deg); }
    }

    .path {
      stroke-dasharray: $offset;
      stroke-dashoffset: 0;
      transform-origin: center;
      stroke: $mint;
      animation:
        dash $duration ease-in-out infinite,
    }

    @keyframes dash {
      0% { stroke-dashoffset: $offset; }
      50% {
        stroke-dashoffset: $offset/4;
        transform:rotate(135deg);
      }
      100% {
        stroke-dashoffset: $offset;
        transform:rotate(450deg);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/lib/util/SpinnerOverlay.vue